import {
  animate,
  state,
  style,
  transition,
  trigger,
} from '@angular/animations';
import { Component, OnInit } from '@angular/core';

/**
 * HoverCardComponent
 *
 * @export HoverCardComponent
 */
@Component({
  selector: 'app-hover-card',
  templateUrl: './hover-card.component.html',
  styleUrls: ['./hover-card.component.scss'],
  animations: [
    trigger('hover', [
      state('in', style({ transform: 'translateY(-10px)' })),
      state('out', style({ transform: 'translateY(0px)' })),
      transition('* => in', [animate('0.05s')]),
      transition('* => out', [animate('0.05s')]),
    ]),
  ],
})
export class HoverCardComponent implements OnInit {

  /**
   * Current Animation State of Card
   */
  state;

  /**
   * Creates an instance of HoverCardComponent.
   */
  constructor() {}

  /**
   * Does Nothing
   */
  ngOnInit() {}

}
